import React from "react";

const OI = {
  TEAL: "#00a87e",
  INK: "#191c1f",
  LIGHT: "#ffffff",
  MUTED: "#8d969e",
  FONT: "'Inter Tight', sans-serif",
  weight: 700,
  tracking: -0.055,
  dotX: 119,
  dotY: 92,
  dotSize: 0.33,
  haloEm: 0.045,
  tileRadius: 0.225,
  tilePad: 1.95,
  oneX: 48,
  oneY: 42,
  immoX: 70,
  immoY: 73,
  immoIconSize: 0.36,
};

function inkOn(bg) {
  const h = bg.replace("#", "");
  const r = parseInt(h.slice(0, 2), 16);
  const g = parseInt(h.slice(2, 4), 16);
  const b = parseInt(h.slice(4, 6), 16);
  const L = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return L > 0.55 ? OI.INK : OI.LIGHT;
}

function OneWord({ fontPx, ink, bg }) {
  const ds = fontPx * OI.dotSize;
  const halo = fontPx * OI.haloEm;
  return (
    <span
      style={{
        position: "relative",
        display: "inline-block",
        whiteSpace: "nowrap",
        fontFamily: OI.FONT,
        fontWeight: OI.weight,
        fontSize: fontPx,
        letterSpacing: `${OI.tracking}em`,
        color: ink,
        lineHeight: 1,
      }}
    >
      On
      <span style={{ position: "relative", display: "inline-block" }}>
        e
        <span
          style={{
            position: "absolute",
            left: `${OI.dotX}%`,
            top: `${OI.dotY}%`,
            transform: "translate(-50%,-50%)",
            width: ds,
            height: ds,
            borderRadius: "50%",
            background: OI.TEAL,
            border: `${halo}px solid ${bg}`,
            boxSizing: "content-box",
          }}
        />
      </span>
    </span>
  );
}

export default function OneImmoMark({ size = 56, bg = "#ffffff", withImmo = true }) {
  const fontPx = size / OI.tilePad;
  const ink = inkOn(bg);
  const immoPx = fontPx * OI.immoIconSize;

  return (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: size * OI.tileRadius,
        background: bg,
        position: "relative",
        flex: "0 0 auto",
      }}
      aria-hidden="true"
    >
      <div
        style={{
          position: "absolute",
          left: `${OI.oneX}%`,
          top: withImmo ? `${OI.oneY}%` : "50%",
          transform: "translate(-50%,-50%)",
          width: "max-content",
        }}
      >
        <OneWord fontPx={fontPx} ink={ink} bg={bg} />
      </div>
      {withImmo && (
        <span
          style={{
            position: "absolute",
            left: `${OI.immoX}%`,
            top: `${OI.immoY}%`,
            transform: "translate(-50%,-50%)",
            whiteSpace: "nowrap",
            fontFamily: OI.FONT,
            fontWeight: 600,
            fontSize: immoPx,
            letterSpacing: `${OI.tracking}em`,
            color: OI.MUTED,
            lineHeight: 1,
          }}
        >
          immo
        </span>
      )}
    </div>
  );
}
